import { combineReducers } from '@reduxjs/toolkit';

// import all common reducers
import uiStateReducers from './ui-state-reducers';


// import all the reducers from the application
import caseSummaryConfigReducer from '../../views/case-summary-one-view/store/reducers/config-reducers'
import caseSummaryDataReducer from '../../views/case-summary-one-view/store/reducers/summary-data-reducers'
import caseDataReducers from '../../views/case-summary-one-view/store/reducers/case-data-reducers';
import informationGovernanceReducers from '../../views/case-summary-one-view/store/reducers/information-governance-reducers';
import igapiReducers from '../../views/case-summary-one-view/store/reducers/igapi-reducers';
import overviewreferenceReducer from '../../views/case-summary-one-view/store/reducers/fetch-overview-reference-reducers';
import overviewreferenceaccessReducer from '../../views/case-summary-one-view/store/reducers/fetch-overview-reference-access-reducers';
import actionButtonSliceReducer from '../../views/case-summary-one-view/store/actionButtonApiCall.slice';
import iframeDataReducer from '../../views/case-summary-one-view/store/reducers/iframe-data-reducer';


import feedbackCsColumnsReducers from '../../views/case-summary-one-view/store/reducers/feedback-cs-columns-reducers';
import feedbackCsReducers from '../../views/case-summary-one-view/store/reducers/feedback-cs-reducers'
import feedbackCsEditReducers from '../../views/case-summary-one-view/store/reducers/feedback-cs-edit-reducers';
import feedbackCsDeleteReducers from '../../views/case-summary-one-view/store/reducers/feedback-cs-delete-reducers';
import feedbackCsAddReducers from '../../views/case-summary-one-view/store/reducers/feedback-cs-add-reducers';



// combine all reducers together
const appReducer = combineReducers({
    uiStates: uiStateReducers,
    caseSummaryConfig: caseSummaryConfigReducer,
    caseSummaryData: caseSummaryDataReducer,
    caseData: caseDataReducers,
    informationGovernanceData: informationGovernanceReducers,
    igapiData: igapiReducers,
    overviewreference: overviewreferenceReducer,
    overviewreferenceaccess: overviewreferenceaccessReducer,
    actionButtonData: actionButtonSliceReducer,
    iframeConfigData: iframeDataReducer,
    feedbackCsColumns: feedbackCsColumnsReducers,
    feedbackCs: feedbackCsReducers,
    feedbackCsAdd: feedbackCsAddReducers,
    feedbackCsEdit: feedbackCsEditReducers,
    feedbackCsDelete: feedbackCsDeleteReducers,

});


const rootReducer = (state: any, action: any) => {
    // if (action.type === 'IS_LOGOUT') {
    //     state = undefined
    // }
    return appReducer(state, action)
}
export default rootReducer;